<template>
  <div class="hero bg-primary-dark-op">
    <div class="hero-inner">
      <div class="content content-full text-center">
        <detective-logo size="180px" color="#D18237"/>
        <h1 class="display-4 font-w700 text-primary-light mb-2">
          <span class="text-uppercase">{{$t('auth.welcomeHero.' + selectedChain)}}</span> {{$t('auth.welcomeHero.detective')}}
        </h1>
        <h2 class="font-w300 text-white-75 mb-4">{{$t('auth.welcomeHero.forensicDataAnalysis')}}</h2>
        <div>
          <router-link :to="{ name: 'login' }" class="btn btn-hero-primary mr-2">
            <i class="fa fa-fw fa-sign-in-alt mr-1"></i> {{$t('auth.welcomeHero.signIn')}}
          </router-link>
          <router-link :to="{ name: 'register' }" class="btn btn-hero-primary">
            <i class="fa fa-fw fa-user-plus mr-1"></i> {{$t('auth.welcomeHero.createAccount')}}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetectiveLogo from '@/components/layout/detectiveLogo'

export default {
  name: 'WelcomeHero',
  components: {
    DetectiveLogo
  },
  computed: {
    selectedLanguage () {
      return this.$store.state.options.selectedLanguage
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    }
  }
}
</script>

<style scoped>
  .hero {
    height: calc(100vh - 40px);
    z-index: 999;
  }
</style>
